<template>
  <div class="custom-footer-container">
    <footer class="footer">
      <ul class="footer__nav">
        <li class="footer__nav-item">
          <a :href="ovhcloudUrl" class="footer__nav-item-link">
            {{$t('footer.copyright')}}<span class="footer__current-year">{{currentYear}}</span>
            {{$t('footer.trademark')}}
          </a>
        </li>
        <li class="footer__nav-item">
          <a :href="termsUrl" class="footer__nav-item-link">
            {{$t('footer.terms')}}
          </a>
        </li>
        <li class="footer__nav-item">
          <a :href="contractsUrl" class="footer__nav-item-link">
            {{$t('footer.contracts')}}
          </a>
        </li>
        <li class="footer__nav-item">
          <a :href="privacyUrl" class="footer__nav-item-link">
            {{$t('footer.privacy')}}
          </a>
        </li>
        <li class="footer__nav-item">
          <a :href="aboutUrl" class="footer__nav-item-link">
            {{$t('footer.about')}}
          </a>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterView",
  data() {
    return {
      currentYear: null,
      termsUrl: '',
      ovhcloudUrl: '',
      contractsUrl: '',
      privacyUrl: '',
      aboutUrl: '',
    }
  },
  created() {
    this.initializeFooter();
  },
  methods: {
    initializeFooter() {
      const now = new Date();
      this.currentYear = now.getFullYear();

      const lang = navigator.language;

      this.ovhcloudUrl = lang === 'fr' ? 'https://www.ovh.com/fr/' : 'https://www.ovh.ie/';
      this.termsUrl = lang === 'fr' ? 'https://www.ovh.com/fr/support/mentions-legales/' : 'https://www.ovh.ie/support/terms-and-conditions/';
      this.contractsUrl = lang === 'fr' ? 'https://www.ovh.com/fr/support/contrats/' : 'https://www.ovh.ie/support/contracts/';
      this.privacyUrl = lang === 'fr' ? 'https://www.ovh.com/fr/protection-donnees-personnelles/' : 'https://www.ovh.ie/personal-data-protection/';
      this.aboutUrl = lang === 'fr' ? 'https://www.ovhcloud.com/fr/about-us/' : 'https://www.ovhcloud.com/en-ie/about-us/';
    }
  }
};
</script>

<style>
.footer {
  background-color: #0050d7;
  /* padding: 2em; */
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  bottom: 0;
}

.footer__nav {
  width: auto;
  max-width: 65em;
  padding-left: 1em;
  padding-right: 1em;
  margin: 0 auto;
  text-align: center;
}

.footer__nav-item {
  display: inline-block;
  list-style: none;
}

.footer__nav-item::after {
  content: "|";
  color: #ffffff;
  margin: 0 0.625em;
}

.footer__nav-item:last-child::after {
  display: none;
}

.footer__nav-item-link {
  font-size: 0.875em;
  color: #ffffff;
  text-decoration: none;
}

.footer__nav-item-link:hover {
  color: #ffffff !important;
}

.footer__nav-item:first-of-type .footer__nav-item-link {
  font-weight: 700;
}

.page-footer > a {
  display: inline-block;
  padding: 1rem 1rem 1rem 0.7rem;
  color: #0050d7;
  font-weight: 600;
  font-size: 1rem;
}
</style>